import { getLink } from '../../../utils/utils';

import author from './author';
const content = {
  esp: (
    `
    <div class="poem">
      <p class="mb-3 text-center bold">* * *</p>
      <p class="poem-block mb-3">
        Ĉiuj esperoj – je splitoj ek!<br/>
        Kaj kvazaŭ al rubujo – al plena forges’!<br/>
        Plu ne estis aspiro, kaj vervo nek,<br/>
        Kaj ĉie atendis nur malsukces’!
      </p>

      <p class="poem-block mb-3">
        Al mi ĉi-jare ĉiuj vojoj – retr’!<br/>
        Sur ĉiuj staras minaca fortres’<br/>
        Aŭ etendiĝas pik-dorna vepr’<br/>
        Kaj ĉie atendas min malsukces’.
      </p>

      <p class="poem-block mb-3">
        Vane strebis mi al trankvila lok’,<br/>
        De ĉiuj flankoj – morda agres’.<br/>
        Jam mi senhelpas pro sufok’,<br/>
        Ja ĉie atendas nur malsukces’.
      </p>

      <p class="poem-block mb-3">
        Vanas cedo kaj vanas rezist’,<br/>
        Ne plenumiĝas ajna promes’.<br/>
        Ripetiĝas la samo kun morna persist’:<br/>
        Denove hodiaŭ trafis min malsukces’.
      </p>

      <p class="poem-block mb-3">
        Mi estas senpova kontraŭ vi, destin’!<br/>
        Sed malgraŭ via konstanta opres’,<br/>
        Mi ĝojas denove oponi vin:<br/>
        Ne, nur hodiaŭ trafis min malsukces’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ĉiuj esperoj…'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;